<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
</script>

<Section backgroundColor="grey-light-medium">
	<p class="text-xl font-medium">
		Have arched windows or want frequent access to the primary glazing?
	</p>
	<p class="font-bold">Explore IndowONE for commercial applications.</p>
	<Button href="/products/indowone-window-inserts" color="blue-grey-light"
		>LEARN MORE</Button
	>
</Section>
